import { SelectField } from "@components/Forms/DefaultInputs";
import {
  type DateInput,
  getJanuaryBudgetYearOptions,
} from "@features/budgets/budgetYearOverride";

interface BudgetYearOverrideSelectProps {
  /** The in-market date the budget year applies to. Renders nothing outside January. */
  date: DateInput | null | undefined;
  /** Empty string means "no choice yet"; the picker is never preselected. */
  value: string;
  onChange: (value: string) => void;
  label?: string;
  required?: boolean;
  disabled?: boolean;
  className?: string;
}

const BudgetYearOverrideSelect = ({
  date,
  value,
  onChange,
  label = "Budget Year",
  required,
  disabled,
  className,
}: BudgetYearOverrideSelectProps) => {
  const options = getJanuaryBudgetYearOptions(date);
  if (options.length === 0) return null;

  return (
    <SelectField
      className={className}
      label={required ? `${label} *` : label}
      fullWidth
      disabled={disabled}
      value={options.includes(value) ? value : ""}
      onChange={(e) => onChange(String(e.target.value))}
      options={options.map((fy) => ({ id: fy, name: fy }))}
    />
  );
};

export default BudgetYearOverrideSelect;
